// @flow

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';
import media from '@leasen_nl/listo/src/helpers/media';
import StyledRow from '@leasen_nl/listo/src/components/row/row.styled';
import type { Theme } from '@types/index';

type Props = {|
  children: Node,
|};

const ConfFormRow = styled<typeof StyledRow, Theme, _>(StyledRow)`
  padding-top: 3.6875rem;
  padding-bottom: 3.6875rem;
  ${media.md(css`
    padding-top: 3.125rem;
    padding-bottom: 3.125rem;
  `)}
  ${media.lg(css`
    padding-top: 4.4375rem;
    padding-bottom: 4.4375rem;
    overflow-x: initial;
  `)}
`;

export default ({ children }: Props) => (
  <ConfFormRow backgroundColor="light">{children}</ConfFormRow>
);
